import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HeaderNav, SocialRibbon } from '@forwardfinancing/component-library';
import { withRouter } from 'react-router-dom';


export class WrappedHeaderNav extends Component {
  render() {
    const loggedInNavItems = [
      {text: 'Home',       url: '/owner',            isStatic: false},
      {text: 'Statements', url: '/owner/statements', isStatic: false},
      {text: 'FAQ',        url: '/owner/faq',        isStatic: false},
      {text: 'Log Out',    url: '/owner/sign_out',   isStatic: false}
    ];

    const loggedOutNavItems = [
      {text: 'Home',             url: 'https://forwardfinancing.com/',                          isStatic: true},
      {text: 'Our Product',      url: 'https://forwardfinancing.com/our-product/',              isStatic: true},
      {text: 'Why Forward',      url: 'https://forwardfinancing.com/why-forward',               isStatic: true},
      {text: 'ISOs',             url: 'https://forwardfinancing.com/isos',                      isStatic: true},
      {text: 'About Us',         url: 'https://www.forwardfinancing.com/our-story/',            isStatic: true},
      {text: 'Log In',           url: '/owner/sign_in',                                         isStatic: false},
      {text: 'Apply Now',        url: 'https://forwardfinancing.com/apply-for-funding',         isStatic: true}
    ];

    return (
      <div className="wrapped-header">
        <SocialRibbon hideItems />
        <HeaderNav navItems={this.props.userData.id ? loggedInNavItems : loggedOutNavItems} />
      </div>
    );
  }
}

WrappedHeaderNav.propTypes = {
  userData: PropTypes.object
};

export default withRouter(connect((state) => {
    return { userData: state.userData };
  }, {})(WrappedHeaderNav)
);
